<template>
  <section class="navigation _py-5">
    <div class="container d-flex align-center justify-between">
      <nav class="navigation__list">
        <div
          v-for="(link, i) in links"
          :key="i"
          v-html="link.txt"
          class="navigation__item _fs-16 _lh-20 _mr-12"
          :class="i > 0 ? '_ml-12' : '_ml-0'"
          @click="dataLayerPush(link.txt, link.component)"
        ></div>
      </nav>

      <div
        class="navigation__more more _fs-16 _ml-12"
        :class="{ more_opened: isMore }"
      >
        <div
          class="more__header d-flex align-center _pl-4"
          @click="isMore = !isMore"
        >
          <span>{{ $t('interface.menu.more') }}</span>

          <ChevronDown class="ctrl__icon _ml-3" />
        </div>
        <div class="navigation__more-menu" v-if="isMore">
          <div
            class="navigation__more-menu-item d-block _mb-4 _fs-16 _lh-24 _tc-dark"
            @click="
              dataLayerPush(
                $t('interface.menu.onboarding'),
                helpers.buildRoute({ name: 'Onboarding' })
              )
            "
          >
            {{ $t('interface.menu.onboarding') }}
          </div>
          <div
            class="navigation__more-menu-item d-block _mb-4 _fs-16 _lh-24 _tc-dark"
            @click="
              dataLayerPush(
                $t('interface.menu.success_wall'),
                helpers.buildRoute({ name: 'SuccessLadder' })
              )
            "
          >
            {{ $t('interface.menu.success_wall') }}
          </div>
          <div
            class="navigation__more-menu-item d-block _mb-4 _fs-16 _lh-24 _tc-dark"
            @click="
              dataLayerPush(
                $t('interface.menu.useful_resources'),
                helpers.buildRoute({ name: 'UsefulResources' })
              )
            "
          >
            {{ $t('interface.menu.useful_resources') }}
          </div>
          <div
            class="navigation__more-menu-item d-block _mb-4 _fs-16 _lh-24 _tc-dark"
            @click="
              dataLayerPush(
                $t('interface.menu.trainings'),
                helpers.buildRoute({ name: 'Trainings' })
              )
            "
          >
            {{ $t('interface.menu.trainings') }}
          </div>
          <div
            v-if="false"
            class="navigation__more-menu-item d-flex _fs-16 _lh-24 _tc-dark"
            @click="
              dataLayerPush(
                'Лидерборд',
                helpers.buildRoute({ name: 'Leaderboard' })
              )
            "
          >
            Лидерборд
            <svg
              style="margin-top: 2px"
              class="_ml-2"
              width="23"
              height="18"
              viewBox="0 0 23 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.20327 6.1679L4.39936 16.6693C4.45249 16.8439 4.6491 16.9302 4.81604 16.8565C10.4364 14.3753 15.8561 15.7174 18.1884 16.8415C18.3547 16.9216 18.555 16.8419 18.6156 16.6675L22.2576 6.19683C22.346 5.94261 22.0809 5.70957 21.8401 5.82994L16.7369 8.38156C16.6016 8.44922 16.437 8.40553 16.3531 8.27964L11.763 1.39444C11.6408 1.2112 11.3694 1.21765 11.2561 1.4065L7.14293 8.26178C7.06228 8.3962 6.89173 8.44587 6.75152 8.37576L1.62444 5.81222C1.38877 5.69439 1.12656 5.91583 1.20327 6.1679Z"
                fill="#FED141"
                stroke="#FED141"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ChevronDown from 'icons/ChevronDown'
import { Trans } from '@/plugins/translation'

export default {
  name: 'AppNavigation',
  components: {
    ChevronDown,
  },
  data: () => ({
    isMore: false,
  }),
  computed: {
    currentLocale() {
      return Trans.currentLocale
    },
    links() {
      if (this.Trans.currentLocale !== 'ru') {
        return [
          {
            txt: this.$t('interface.menu.hngrow'),
            component: this.helpers.buildRoute({ name: 'HNGrow' }),
          },
          {
            txt: this.$t('interface.menu.academy'),
            component: this.helpers.buildRoute({ name: 'SuccessAcademy' }),
          },
          {
            txt: this.$t('interface.menu.intensives'),
            component: this.helpers.buildRoute({ name: 'Intensives' }),
          },
          {
            txt: this.$t('interface.menu.network_security'),
            component: this.helpers.buildRoute({ name: 'NetworkSecurity' }),
          },
          {
            txt: this.$t('interface.menu.system'),
            component: this.helpers.buildRoute({ name: 'System' }),
          },
        ]
      }
      return [
        {
          txt: this.$t('interface.menu.hngrow'),
          component: this.helpers.buildRoute({ name: 'HNGrow' }),
        },
        {
          txt: this.$t('interface.menu.academy'),
          component: this.helpers.buildRoute({ name: 'SuccessAcademy' }),
        },
        {
          txt: this.$t('interface.menu.intensives'),
          component: this.helpers.buildRoute({ name: 'Intensives' }),
        },
        // {
        //   txt: this.$t('interface.menu.webinars'),
        //   component: this.helpers.buildRoute({ name: 'Webinars' }),
        // },
        {
          txt: this.$t('interface.menu.network_security'),
          component: this.helpers.buildRoute({ name: 'NetworkSecurity' }),
        },
        {
          txt: this.$t('interface.menu.system'),
          component: this.helpers.buildRoute({ name: 'System' }),
        },
      ]
    },
  },
  methods: {
    dataLayerPush(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'ev_header_menu',
          param_value: this.helpers.stripHtml(txt),
        })
      }
      if (path && this.$route.name !== path.name) {
        this.$router.push(path)
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.navigation {
  display: flex;
  width: 100%;
  background-color: color(green-second);

  &__list {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__item {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    text-decoration: none;
    color: color(green-light);
    height: 100%;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      color: darken(color(green-light), 10);
    }

    &::before {
      content: '';
      position: absolute;
      right: -48px;
      width: 1px;
      height: 24px;
      background-color: color(green);
    }
  }

  &__more {
    &-menu {
      padding: 16px;
      border: 1px solid #f8f8f8;
      box-shadow: 7px 7px 4px rgba(0, 0, 0, 0.01),
        4px 4px 3px rgba(0, 0, 0, 0.05), 2px 2px 3px rgba(0, 0, 0, 0.09),
        0px 0px 1px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
      width: max-content;
      max-width: 245px;
      position: absolute;
      top: calc(100% + 28px);
      right: 0;
      background-color: #fff;
      border-radius: 8px;

      &-item {
        transition: 0.3s;
        &:hover {
          color: color(green);
        }
        cursor: pointer;
      }
    }
  }
}

.ctrl__icon {
  transition: all 0.3s ease;
}

.more {
  position: relative;
  color: color(green-light);

  &_opened .ctrl__icon {
    transform: scaleY(-1);
  }

  &__header {
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      color: darken(color(green-light), 10);
    }
  }
}
</style>
